import createSubtitleFabric from "../../../general/CoreHeader/components/Subtitle/subtitleFabric";
import { createDisplayNameForHeader } from "../../utils/createDisplayName";
import { createTestIdForHeader } from "../../utils/createTestId";

const displayName = createDisplayNameForHeader("Subtitle");
const testId = createTestIdForHeader("subtitle");

const HeaderSubtitle = createSubtitleFabric(displayName, testId);

export default HeaderSubtitle;
